import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Vendor } from '@/lib/types';

export interface VendorInput {
    name: string;
    phone: string;
    email?: string;
    address?: string;
    notes?: string;
}

export async function listVendors(shopId: number | string): Promise<Vendor[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.vendors.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createVendor(
    shopId: number | string,
    input: VendorInput
): Promise<Vendor> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.vendors.CREATE(shopId),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function updateVendor(
    shopId: number | string,
    id: number | string,
    input: Partial<VendorInput>
): Promise<Vendor> {
    const res = await apiClient.put<{ data: any }>(
        API_ENDPOINTS.vendors.UPDATE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deleteVendor(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.vendors.DELETE(shopId, id), {
        headers: APIHeadersWithAuth(),
    });
}

export interface VendorWalletInput {
    amount: number;
    paymentMethod: string;
    note?: string;
}

export async function advanceVendor(
    shopId: number | string,
    id: number | string,
    input: VendorWalletInput
): Promise<Vendor> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.vendors.ADVANCE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function refundVendor(
    shopId: number | string,
    id: number | string,
    input: VendorWalletInput
): Promise<Vendor> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.vendors.REFUND(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export interface VendorStatement {
    vendorId: number;
    vendorName: string;
    advanceBalance: number;
    advanced: number;
    refunded: number;
    drawn: number;
    duesOwed: number;
    lines: { at: string; kind: string; label: string; amount: number }[];
}

export async function getVendorStatement(
    shopId: number | string,
    id: number | string
): Promise<VendorStatement> {
    const res = await apiClient.get<{ data: VendorStatement }>(
        API_ENDPOINTS.vendors.STATEMENT(shopId, id),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}
